export const normalizeApiError = (error) => {
  const payload = error?.response?.data;
  const fieldError = Array.isArray(payload?.errors) ? payload.errors[0] : null;

  return {
    success: false,
    message:
      payload?.message ||
      fieldError?.message ||
      fieldError?.msg ||
      error?.message ||
      'Something went wrong',
    errors: Array.isArray(payload?.errors) ? payload.errors : [],
    statusCode: error?.response?.status,
    raw: error,
  };
};

export const getApiErrorMessage = (error, fallback = 'Something went wrong') =>
  error?.apiError?.message || normalizeApiError(error).message || fallback;
